import type Result from './Result'

import { UnloadedPersistedType } from '../../../Foobara/Autocrud/Types/PersistedType/Unloaded'

export default function castJsonResult (json: any): Result {
  json.persisted_type = new UnloadedPersistedType(json.persisted_type)
  return json
}
